<template>
  <v-dialog
    v-model="dialog"
    max-width="700px"
  >
    <v-form
      ref="form"
      v-model="valid"
      :lazy-validation="true"
      autocomplete="off"
    >
      <v-card>
        <v-card-title>
          <span class="headline font-weight-bold">Modifica Accessorio</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="true"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="editedItem.posix"
                      label="Data di acquisto"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="editedItem.posix"
                    no-title
                    scrollable
                    actions
                    locale="it-IT"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="menu = false"
                    >OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-select
                  label="Fornitore"
                  :items="suppliers"
                  item-text="name"
                  item-value="id"
                  v-model="editedItem.supplier_id"
                  :rules="[rules.required]"
                  required
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <v-text-field
                  v-model="editedItem.serial_code"
                  label="EAN"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.brand"
                  label="Marchio"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.model"
                  label="Prodotto"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.color"
                  label="Colore"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.desctiption"
                  label="Modello"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.cost"
                  label="Costo"
                  type="number"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.price"
                  label="Prezzo"
                  type="number"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="editedItem.amount"
                  label="Quantità"
                  type="number"
                  :rules="[rules.required]"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="close"
          >Cancella</v-btn>
          <v-btn
            color="primary"
            text
            @click="save"
          >Salva</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import axios from 'axios'
  import { mapMutations, mapGetters } from 'vuex'

  export default {
    name: 'EditForm',

    data() {
      return {
        editedItem: {},
        suppliers: [],
        valid: false,
        menu: false,
        rules: {
          required: value => !!value || 'Campo obbligatorio.',
        },
        config: {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
          }
        },
      }
    },

    props: {
      item: { type: Object }
    },

    computed: {
      ...mapGetters([
        'getAccessoriEdit'
      ]),
      dialog: {
        get() {
          return this.getAccessoriEdit
        },
        set() {
          this.CHANGE_ACCESSORI_EDIT(false)
        }
      }
    },

    methods: {
      ...mapMutations([
        'CHANGE_ACCESSORI_EDIT'
      ]),

      async getSuppliers() {
        let { data } = await axios.get(`${process.env.VUE_APP_API}/suppliers`, this.config)

        this.suppliers = data
      },

      close() {
        this.CHANGE_ACCESSORI_EDIT(false)
      },

      async save() {
        if (this.$refs.form.validate()) {

          this.$emit('edit-submit', 'reset')

          const { data } = await axios.post(`${process.env.VUE_APP_API}/accessories/update`, this.editedItem, this.config)

          if (data.status) {

            this.$emit('edit-submit', 'ok')
            this.close()
          } else {

            this.$emit('edit-submit', 'error')
          }
        }
      }
    },

    watch: {
      dialog(val) {
        val || this.close() && this.CHANGE_ACCESSORI_EDIT(false)
      },
      item(val) {
        this.editedItem = val
      }
    },

    async mounted() {
      await this.getSuppliers()
    }
  }
</script>

<style>
</style>